import React from 'react';
import { Text } from '@topconagriculture/react-components';
import { makeStyles } from '@material-ui/core/styles';
export const useStyles = (diameter, color, fontSize) => makeStyles(() => ({
    warning: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        fontSize,
        borderRadius: '50%',
        width: diameter,
        height: diameter,
        backgroundColor: color,
        cursor: 'pointer',
    },
    warningWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        textAlign: 'center',
    },
    capitalized: { textTransform: 'capitalize' },
}));
export const Warning = (props) => {
    const { diameter, color, amount, fontSize, onClick, title = '' } = props;
    const classes = useStyles(diameter, color, fontSize)();
    return (React.createElement("div", { className: classes.warningWrapper },
        React.createElement("div", { onClick: onClick, className: classes.warning }, amount),
        !!title && React.createElement(Text, { className: classes.capitalized }, title)));
};
//# sourceMappingURL=Warning.js.map